import * as types from './types';
import Api from '../lib/api';

export function jobFunction() {
    return (dispatch, getState) => {
        return Api.get('Combo/job-function').then(response => {
            dispatch(jobFunctionResult(response.data.functions ));
            return response.data.functions;
        }).catch(err => {
            console.error(err);
        });

    }
}

function jobFunctionResult(functions) {
    return {
        type: types.COMBO_JOB_FUNCTION,
        functions
    }
}

export function jobLocation() {
    return (dispatch, getState) => {
        return Api.get('Combo/job-location').then(response => {
            dispatch(jobLocationResult(response.data.locations ));
            return response.data.locations;
        }).catch(err => {
            console.error(err);
        });

    }
}

function jobLocationResult(locations) {
    return {
        type: types.COMBO_JOB_LOCATION,
        locations
    }
}

export function jobType() {
    return (dispatch, getState) => {
        return Api.get('Combo/job-type').then(response => {
            dispatch( jobTypeResult(response.data.types) );
            return response.data.types;
        }).catch(err => {
            console.error(err);
        });
    }
}

function jobTypeResult(jobType) {
    return {
        type: types.COMBO_JOB_TYPE,
        jobType
    }
}



// WEBPACK FOOTER //
// ./src/actions/combo.js